import React from 'react';
import Home from './components/home';
/*
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import About from './components/About';
import Contact from './components/Contact';
import Projects from './components/Projects';
import Menu from './components/Menu';
import Footer from './components/footer';
*/



function App() {
  return (
      <Home />
  );
}

export default App;
